import TableContainer from "@mui/material/TableContainer";
import Table from "@mui/material/Table";
import TableHead from "@mui/material/TableHead";
import TableCell from "@mui/material/TableCell";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Paper from "@mui/material/Paper";
import StyledTableCell from "../../layouts/table/StyledTableCell";
import StyledTableRow from "../../layouts/table/StyledTableRow";
import {Card, CardContent, CardHeader} from "@mui/material";
import Typography from "@mui/material/Typography";
import ControlPointIcon from "@mui/icons-material/ControlPoint";
import Button from "@mui/material/Button";
import React, {useCallback, useEffect, useState} from "react";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import DeleteItemModal from "../DeleteItemModal";
import {toast} from "react-toastify";
import VehicleService from "../../../services/vehicle.service";
import VehicleModal from "./VehicleModal";


const initialVehicle = {
    id: '',
    plate: '',
    capacity: '',
    description: '',
    type: '',
    driverId: '',
    active: true
}

const VehicleList = () => {

    const [vehicles, setVehicles] = useState([]);
    const [selectedVehicle, setSelectedVehicle] = useState(initialVehicle)
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    //modals
    const [openCreateVehicleModal, setOpenCreateVehicleModal] = useState(false);
    const [openEditVehicleModal, setOpenEditVehicleModal] = useState(false);
    const [openDeleteVehicleModal, setOpenDeleteVehicleModal] = useState(false);

    const fetchVehiclesHandler = useCallback(async () => {
        setIsLoading(true);
        setError(null)
        try {
            const vehicleList = await VehicleService.getVehicles();
            setVehicles(vehicleList);

        } catch (error) {
            setError(error.message);
        }
        setIsLoading(false);
    }, []);

    const removeVehicleHandler = async () => {
        try {
            await VehicleService.removeVehicle(selectedVehicle.id);
            toast.success('Se ha eliminado correctamente');
            toggleModal('remove', false)
        } catch (e) {
            console.error(e);
            toast.error('There was an error trying to remove this interlocutor');
        }
    };

    const openCreateVehicleHandler = () => {
        setSelectedVehicle(initialVehicle)
        toggleModal('create', true);
    }

    const openEditVehicleHandler = (vehicle) => {
        setSelectedVehicle(selectedInterlocutor => vehicle)
        toggleModal('edit', true);
    }

    const openRemoveVehicleHandler = (vehicle) => {
        setSelectedVehicle(vehicle)
        toggleModal('remove', true);
    }

    const toggleModal = (modalType, open) => {
        switch (modalType) {
            case 'create':
                setOpenCreateVehicleModal(open);
                break;
            case 'edit':
                setOpenEditVehicleModal(open);
                break;
            case 'remove':
                setOpenDeleteVehicleModal(open);
                break;
            default:
                console.error(`Modal type ${modalType} is not valid`);
        }

    }

    useEffect(() => {
        if (!openCreateVehicleModal && !openDeleteVehicleModal && !openEditVehicleModal) {
            void fetchVehiclesHandler();
        }

    }, [openCreateVehicleModal, openDeleteVehicleModal, openEditVehicleModal,
        fetchVehiclesHandler])


    return (
        <>
            <Card>
                <CardHeader
                    title={
                        <Typography variant='h4'>
                            Vehiculos
                        </Typography>
                    }
                    action={
                        <Button variant="outlined" startIcon={<ControlPointIcon/>}
                                onClick={openCreateVehicleHandler}>
                            Añadir nuevo
                        </Button>
                    }
                >
                </CardHeader>
                <CardContent>
                    {isLoading && vehicles.length <= 0 && <p>Cargando vehiculos...</p>}
                    {!isLoading && !error && vehicles.length === 0 && <p>No se han creado vehiculos.</p>}
                    {error && <p> {error} </p>}
                    {vehicles.length > 0 &&
                        <TableContainer component={Paper} sx={{maxWidth: '100%'}}>
                            <Table sx={{minWidth: 400}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell>Placa</StyledTableCell>
                                        <StyledTableCell align="right">Capacidad</StyledTableCell>
                                        <StyledTableCell align="right">Descripción</StyledTableCell>
                                        <StyledTableCell align="right">Tipo</StyledTableCell>
                                        <StyledTableCell align="right">Id fiscal</StyledTableCell>
                                        <StyledTableCell align="right">Tranportadora/Conductor</StyledTableCell>
                                        <StyledTableCell align="right">Estado</StyledTableCell>
                                        <StyledTableCell align="right"/>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {vehicles.map((vehicle) => (
                                        <StyledTableRow
                                            key={vehicle.id}
                                            sx={{'&:last-child td, &:last-child th': {border: 0}}}
                                        >
                                            <TableCell component="th" scope="row">
                                                {vehicle.plate}
                                            </TableCell>
                                            <TableCell align="right">{vehicle.capacity}</TableCell>
                                            <TableCell align="right">{vehicle.description}</TableCell>
                                            <TableCell align="right">{vehicle.type}</TableCell>
                                            <TableCell align="right">
                                                {`${vehicle.driver?.identificationType}: ${vehicle.driver?.identification}`}
                                            </TableCell>
                                            <TableCell align="right">{vehicle.driver?.name}</TableCell>
                                            <TableCell
                                                align="right">{vehicle.active ? 'Activo' : 'Inactivo'}</TableCell>
                                            <TableCell align="right">
                                                <Button onClick={() => openEditVehicleHandler(vehicle)}>
                                                    <EditIcon/>
                                                </Button>
                                                <Button onClick={() => openRemoveVehicleHandler(vehicle)}>
                                                    <DeleteIcon color={'warning'}/>
                                                </Button>
                                            </TableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>}
                </CardContent>
            </Card>

            {/*modals*/}
            <VehicleModal open={openCreateVehicleModal}
                          modalType="CREATE"
                          vehicle={selectedVehicle}
                          onClose={() => toggleModal('create', false)}/>
            <VehicleModal open={openEditVehicleModal}
                          modalType="UPDATE"
                          vehicle={selectedVehicle}
                          onClose={() => toggleModal('edit', false)}/>
            <DeleteItemModal open={openDeleteVehicleModal}
                             onClose={() => toggleModal('remove', false)}
                             onRemove={removeVehicleHandler}
                             itemName={selectedVehicle.plate}
                             item={"vehiculo"}/>
        </>

    )
}

export default VehicleList;